import { info_tab, preview_tab } from '../../../../../../views/contract/template';

export default {
  title: 'Modello contratto',
  tabs: {
    [info_tab]: 'Info',
    [preview_tab]: 'Anteprima',
  },
  sections: {
    subscription: 'Abbonamento',
    setup_cost: 'Costo di configurazione',
    preview: 'Anteprima',
  },
  form: {
    has_trial: {
      label: 'Aggiungi giorni di prova',
    },
    trial_days: {
      label: 'Giorni di prova gratuiti',
      placeholder: '7',
      validation: {
        required: 'I giorni di prova sono obbligatori',
        min: '{{value}} è il valore minimo per i giorni di prova',
      },
    },
  },
  buttons: {
    apply: 'Applica modifiche',
    download: 'Scarica',
    apply_changes: 'Applica modifiche',
  },
  files: {
    contract: '{{provider}}-contract-template-{{company}}.pdf',
  },
  toasts: {
    failed_to_load_data: 'Caricamento anteprima non riuscito',
  },
};
